import * as React from 'react';
import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBoxWithStaticPrefix } from './TextBoxWithStaticPrefixV4';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState, useFieldApi } from 'informedv4';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';

interface ConfigFieldTextBoxProps {
    id: string;
    name: string;
    field: string;
    className: string;
    siteNumber: string;
    disabled?: boolean;
    validated: boolean;
    required: boolean;
    autoComplete?: string;
    type: string;
    itemId: ConfigurableDataItemIds;
}

export const ConfigFieldTextBoxStaticPrefix = (props: ConfigFieldTextBoxProps): JSX.Element => {
    const {
        id,
        name,
        field,
        className,
        siteNumber,
        disabled,
        validated,
        required,
        type,
        autoComplete,
        itemId,
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { error, showError } = useFieldState(field);
    const fieldApi = useFieldApi(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className}>
                <label htmlFor={id}>{item.displayText}</label>
                <TextBoxWithStaticPrefix
                    id={id}
                    name={name}
                    field={field}
                    className={inputClasses(error as string)}
                    type={type}
                    staticpart={siteNumber}
                    validate={ConfigFieldValidation(item, required, validated)}
                    autoComplete={autoComplete}
                    disabled={disabled}
                    />
            </div>
        </Condition>
    </>
}
